import type React from 'react';

import QuickReplyList from '../../../containers/QuickReplyList';
import type { Button, CarouselData } from '../../../types/ChatWindow';
import type { MessageScheme } from '../../../types/configs';

type TListProps = {
  elements: CarouselData['elements'];
  handleClick: (clickedButton: Button) => void;
  scheme: MessageScheme;
};

export const CarouselList: React.FC<TListProps> = ({
  elements,
  handleClick,
  scheme,
}) => {
  const buttons: Button[] = elements.map((element) => ({
    title: element.title,
    payload: element.buttons[0].payload,
  }));

  return (
    <QuickReplyList
      buttons={buttons}
      scheme={scheme}
      onClick={handleClick}
      isFromMenu={false}
    />
  );
};
